import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, DOCUMENT, PathLocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http"; // Import 

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from "@angular/material/icon";
import { MatTableFilterModule } from 'mat-table-filter';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';

import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

import { BoardPoiliciesComponent } from './board-poilicies/board-poilicies.component';
import { CategoryComponent } from './Components/category/category.component';
import { PolicyComponent } from './Components/policy/policy.component';
import { CounterComponent } from './Components/counter/counter.component';
import { UserComponent } from './Components/user/user.component';
import { SoftwareInfoComponent } from './Components/SMM/software-info/software-info.component';
import { PolicyManagementComponent } from './Components/policy-management/policy-management.component';
import { PrincipalComponent } from './Components/PrincipalInfo/principal/principal.component';
import { PolicyPDFViwerComponent } from './Components/policy-pdfviwer/policy-pdfviwer.component';

import { GuiGridModule } from '@generic-ui/ngx-grid';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule} from '@angular/material/card';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    BoardPoiliciesComponent,
    CategoryComponent,
    PolicyComponent,
    CounterComponent,
    UserComponent,
    SoftwareInfoComponent,
    PolicyManagementComponent,
    PrincipalComponent,
    PolicyPDFViwerComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatListModule,
    HttpClientModule,
    GuiGridModule,
    Ng2SmartTableModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule,
    MatTableFilterModule,
    MatButtonToggleModule,
    MsalModule.forRoot( new PublicClientApplication({
      auth: {
        clientId: 'a08b312a-21fb-4728-8d4f-7f5fed92e035', // Application (client) ID from the app registration
        authority: 'https://login.microsoftonline.com/eeacb5cb-5370-4358-a96a-a3783c95d422', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
        //redirectUri: 'http://localhost:4200/schoolboardpolicy'// This is your redirect URI
        //redirectUri: 'https://web01cdev.browardschools.local/schoolboardpolicy'// This is your redirect URI
        redirectUri: 'https://schoolinfo.browardschools.com/schoolboardpolicy'// This is your redirect URI
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      }
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
        }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([ 
          ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: LocationStrategy, 
      useClass: PathLocationStrategy,
    },
    MsalGuard
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
